"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Settings = _interopRequireDefault(require("./Settings"));

var _SizeSettings = _interopRequireDefault(require("./SizeSettings"));

var _GridSettings = _interopRequireDefault(require("./GridSettings"));

var _SkinSettings = _interopRequireDefault(require("./SkinSettings"));

var _AlignSettings = _interopRequireDefault(require("./AlignSettings"));

var _ValignSettings = _interopRequireDefault(require("./ValignSettings"));

var _PlacementSettings = _interopRequireDefault(require("./PlacementSettings"));

var _ColorSettings = _interopRequireDefault(require("../Color/ColorSettings"));

var _TextColorSettings = _interopRequireDefault(require("../Color/TextColorSettings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const templates = {
  "list": _Settings.default,
  "grid": _GridSettings.default,
  "size": _SizeSettings.default,
  "skin": _SkinSettings.default,
  "align": _AlignSettings.default,
  "valign": _ValignSettings.default,
  "placement": _PlacementSettings.default,
  "color": _ColorSettings.default,
  "textColor": _TextColorSettings.default
};
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex"
  }
}));

const SettingsItem = (_ref) => {
  let name = _ref.name,
      type = _ref.type,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "type"]);

  let SettingsTemplate;

  if (type && templates[type]) {
    SettingsTemplate = templates[type];
  } else if (name && templates[name]) {
    SettingsTemplate = templates[name];
  } else {
    SettingsTemplate = templates["list"];
  }

  return _react.default.createElement(SettingsTemplate, _extends({}, props, {
    name: name,
    type: type
  }));
};

const NavSettings = ({
  className,
  settings = [],
  onSettings
}) => {
  const classes = useStyles();

  if (!settings.length) {
    return false;
  }

  return _react.default.createElement("nav", {
    className: className || classes.root
  }, settings && settings.map((button, index) => _react.default.createElement(SettingsItem, _extends({}, button, {
    onSettings: onSettings,
    key: index
  }))));
};

var _default = NavSettings;
exports.default = _default;
module.exports = exports.default;